<template>
  <div class="content">
    <b-container class="p-0 m-0 top-metrics-container">
      <div>
        <card class="no-border-card" body-classes="px-0 pb-1" footer-classes="pb-2">
          <template slot="header">
            <b-row slot="header">
              <b-col>
                <span class="h4 font-weight-bold mb-0 nowrap" v-if="title">{{ title }}</span>
              </b-col>
              <b-col id="topmetrics" class="font-weight-bold mb-0 text-right nowrap">
								<span class="h6 font-weight-bold mb-0" v-if="volumeT" style="margin-left: -4px">
									<base-button
                      size="xs"
                      type="secondary"
                      class="p-1 border-radius-none"
                      @click="changeTopMetricTab(volumeT)"
                      v-bind:class="btnActivated === volumeT ? 'bg-warning text-white' : ''"
                  >{{ volumeT }}</base-button
                  >
								</span>
                <span class="h6 font-weight-bold mb-0" v-if="sessionT">
									<base-button
                      size="xs"
                      type="secondary"
                      class="p-1 border-radius-none"
                      @click="changeTopMetricTab(sessionT)"
                      v-bind:class="btnActivated === sessionT ? 'bg-warning text-white' : ''"
                  >{{ sessionT }}</base-button
                  >
								</span>
                <span class="h6 font-weight-bold mb-0" v-if="overageT">
									<base-button
                      size="xs"
                      type="secondary"
                      class="p-1 border-radius-none"
                      @click="changeTopMetricTab(overageT)"
                      v-bind:class="btnActivated === overageT ? 'bg-warning text-white' : ''"
                  >
										{{ overageT }}</base-button
                  >
								</span>
                <span class="h6 font-weight-bold mb-0" v-if="alertT">
									<base-button
                      size="xs"
                      type="secondary"
                      class="p-1 border-radius-none"
                      @click="changeTopMetricTab(alertT)"
                      v-bind:class="btnActivated === alertT ? 'bg-warning text-white' : ''"
                  >
										{{ alertT }}</base-button
                  >
								</span>
                <span class="h6 font-weight-bold mb-0" v-if="zeroT">
									<base-button
                      size="xs"
                      type="secondary"
                      class="p-1 mr-1"
                      @click="changeTopMetricTab(zeroT)"
                      v-bind:class="btnActivated === zeroT ? 'bg-warning text-white' : ''"
                  >
										{{ zeroT }}</base-button
                  >
								</span>
                <slot name="icon" class="pl-2">
                  <b-icon
                      id="tm1"
                      icon="question-circle"
                      variant="orange"
                      class="mr-1 vertical-align-35"
                      v-b-tooltip.hover.top="tooltip"
                  ></b-icon>
                </slot>
                <slot name="icon" class="pl-2 ml-2">
                  <b-icon
                      :icon="icon1"
                      variant="orange"
                      class="vertical-align-35"
                      @click="topMetricsToggle()"
                      v-b-tooltip.hover.top="'Click here to enable or disable this item'"
                  ></b-icon>
                </slot>
              </b-col>
            </b-row>
          </template>

          <transition name="slide-fade">
            <div v-if="toggleStatus">
              <div class="text-center w-100">
                <b-icon
                    icon="three-dots"
                    class="text-center"
                    animation="cylon"
                    font-scale="4"
                    v-if="loadingStatus"
                ></b-icon>
              </div>
              <div class="mb-3" v-if="!loadingStatus">
                <b-row class="m-3">
                  <b-col cols="12" xl="8" lg="7" md="7" sm="6">
                    <b-form-group
                        label=""
                        label-for="per-page-select"
                        label-cols-sm="0"
                        label-cols-md="0"
                        label-cols-lg="0"
                        label-align-sm="center"
                        label-size="sm"
                        class="mb-2 per-page-select"
                    >
                      <label for="per-page-select" class="mr-2 text-sm mt-1 mr-4">Show</label>
                      <b-form-select
                          id="per-page-select"
                          class="diameter-report-select"
                          v-model="perPage"
                          :options="pageOptions"
                          size="sm"
                          v-on:input="changePageOption(perPage)"
                      ></b-form-select>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" xl="4" lg="5" md="5" sm="6" class="customer-table-select">
                    <b-form-group
                        label=""
                        label-for="filter-input"
                        label-align-sm="right"
                        label-size="sm "
                        class="mb-0 per-page-select"
                    >
                      <label for="filter-input" class="text-sm mr-2 mt-1">Search:</label>
                      <b-input-group size="sm">
                        <b-form-input id="filter-input2" v-model="filter" class="mb-4"></b-form-input>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                </b-row>

                <div class="">
                  <b-table
                      head-row-variant="primary"
                      id="inventoryTable"
                      class="primary-table"
                      sticky-header="true"
                      :items="tableData"
                      :fields="tableColumns"
                      :current-page="currentPage"
                      :per-page="perPage"
                      :filter="filter"
                      :filter-included-fields="filterOn"
                      :sort-by.sync="sortBy"
                      :sort-desc.sync="sortDesc"
                      :sort-direction="sortDirection"
                      show-empty
                      responsive
                      striped
                      hover
                      @filtered="onFiltered"
                  >
                    <template #cell(IMSI)="row">
                      <span v-if="isIOTOnly">
                        XXXXX{{ row.value.slice(5) }}
                      </span>
                      <span v-else>
											<b-link
                          :disabled="isIOTOnly"
                          class="d-flex"
                          :to="'/sim_detail/:?imsi=' + row.item['IMSI']"
                      >
												{{ row.value }} <i class="ni ni-curved-next ml-2 mt-1"></i>
											</b-link>
                      </span>

                    </template>
                  </b-table>
                </div>

                <b-row class="mt-4">
                  <b-col>
                    <p class="ml-3 nowrap">{{ startPage() }} - {{ lastPage() }} of {{ totalRows }}</p>
                  </b-col>
                  <b-col>
                    <b-pagination
                        class="flex-fill-custom pr-4 ml-3 justify-content-end"
                        v-model="currentPage"
                        :total-rows="totalRows"
                        :per-page="perPage"
                        size="sm"
                    ></b-pagination>
                  </b-col>
                </b-row>
              </div>
            </div>
          </transition>
        </card>
      </div>
    </b-container>
  </div>
</template>
<script>
import {Option, Select, Table, TableColumn} from "element-ui";
import {BasePagination} from "../../../components";
import cardOpenStatusDirective from "../../../common/directive/card-open-status-directive";
import pagination from '../../../common/format/pagination'
import configDirective from "../../../common/directive/config-directive.js";

export default {
  components: {
    BasePagination,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },
  props: {
    type: {
      type: String,
      default: "primary",
    },
    tabId: String,
    icon: String,
    title: String,
    volumeT: String,
    sessionT: String,
    overageT: String,
    alertT: String,
    zeroT: String,
    iconClasses: [String, Array],
    color: String,
    tooltip: String,
  },
  data() {
    return {
      isIOTOnly: configDirective.isIOTOnly(),
      loadingStatus: true,
      toggleStatus: false,
      icon1: "arrow-right-square",
      downIcon: "arrow-down-square",
      rightIcon: "arrow-right-square",
      btnActivated: "Data Volume",
      propsToSearch: ["IMSI", "Data Volume"],
      tableColumns: [],
      tableData: [],
      selectedRows: [],
      totalRows: 0,
      currentPage: 1,
      perPage: 10,
      fromPage1: 1230,
      pageOptions: [5, 10, 25],
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      filterOn: [],
    };
  },
  mounted() {
    this.getCardStatus();
    try {
      this.$root.$on("topMetrics", $event => {
        this.loadingStatus = false;
        let i = 1;
        this.tableColumns = [];
        this.tableData = [];
        switch (this.btnActivated) {
          case this.volumeT: {
            this.tableColumns = dataVolumeColumn;
            break;
          }
          case this.sessionT: {
            this.tableColumns = dataSessionColumn;
            break;
          }
          case this.overageT: {
            this.tableColumns = dataOverageColumn;
            break;
          }
          case this.alertT: {
            this.tableColumns = alertColumn;
            break;
          }
          case this.zeroT: {
            this.tableColumns = zeroSessionColumn;
            break;
          }
        }
        if ($event && !$event.Error && !$event.includes('NULL')) {
          $event.map(item => {
            item.No = i;
            i++;
          });

          this.tableData = $event;
          this.totalRows = $event.length;
          this.getTotalRows();
        } else {
          this.fromPage1 = 0;
          this.totalRows = 0
        }
      });
    } catch (e) {
      console.error('TopMetrics FAIL');
      console.error(e);
    }

    this.getTotalRows();
  },
  methods: {
    getTotalRows() {
      if (this.perPage > this.totalRows) {
        this.fromPage1 = this.totalRows;
      } else {
        this.fromPage1 = this.perPage;
      }
    },
    changePageOption(page) {
      this.fromPage1 = page;
    },
    getCardStatus() {
      if (cardOpenStatusDirective.getOpenCardStatus()) {
        let cardStatus = cardOpenStatusDirective.getOpenCardStatus()["topMetrics-collapse"];
        if (cardStatus) {
          this.icon1 = this.downIcon;
          this.toggleStatus = cardStatus;
        }
      }
    },

    startPage() {
      return pagination.startPageFunc(this.currentPage, this.perPage)
    },
    lastPage() {
      return pagination.lastPageFunc(this.currentPage, this.perPage, this.totalRows)
    },

    changeTopMetricTab(title) {
      this.loadingStatus = true;
      this.$emit("changeTopMetricTab", title);
      this.btnActivated = title;
    },

    topMetricsToggle() {
      let status = cardOpenStatusDirective.setTopMetricsStatus();
      if (status) {
        this.toggleStatus = !this.toggleStatus;
        if (this.toggleStatus) {
          this.icon1 = this.downIcon;
        } else {
          this.icon1 = this.rightIcon;
        }
        this.$root.$emit("topMetricsOpen", this.btnActivated);
      }
    },

    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
  },
};

let dataVolumeColumn = [
  {key: "No", label: "#"},
  {key: "IMSI", label: "IMSI", sortable: true, sortDirection: "desc"},
  {key: "Count", label: "Count", sortable: true, sortDirection: "desc"},
];

let dataSessionColumn = [
  {key: "No", label: "#"},
  {key: "IMSI", label: "IMSI", sortable: true, sortDirection: "desc"},
  {key: "Count", label: "Count", sortable: true, sortDirection: "desc"},
];

let dataOverageColumn = [
  {key: "No", label: "#"},
  {key: "Bucket", label: "Bucket", sortable: true, sortDirection: "desc"},
  {key: "IMSI", label: "IMSI", sortable: true, sortDirection: "desc"},
  {key: "Data Volume", label: "Overage", sortable: true, sortDirection: "desc"},
];

let alertColumn = [
  {key: "No", label: "#"},
  //{key: "description", label: "Alerts", sortable: true, sortDirection: "desc"},
  //{key: "date_created", label: "Date", sortable: true, sortDirection: "desc"},
  //{key: "imsi", label: "IMSI", sortable: true, sortDirection: "desc"},
  {key: "IMSI", label: "IMSI", sortable: true, sortDirection: "desc"},
  {key: "Count", label: "Count", sortable: true, sortDirection: "desc"},
];

let zeroSessionColumn = [
  {key: "No", label: "#"},
  {key: "IMSI", label: "IMSI", sortable: true, sortDirection: "desc"},
  {key: "Count", label: "Count", sortable: true, sortDirection: "desc"},
//	{key: "date_created", label: "Date", sortable: true, sortDirection: "desc"},
//	{key: "Zero Session", label: "Value", sortable: true, sortDirection: "desc"},
];
</script>
